export default {
  navtab: {
    login: '登入',
    register: '註冊',
    memberCenter: '會員中心',
    logout: '登出',
    BusinessCenter: '業務中心',
    bindBank: '綁定銀行卡',
    editInfo: '修改資料',
    store: '加購資金',
    withdraw: '線上提款',
    record: '結算明細'
  },
  btn: {
    start: '開始管理',
    startNow: '立即開始',
    OverviewMore: '了解更多',
    QuickOverview: '快速了解',
    nowReg: '立即註冊',
    backInd: '回到首頁',
    haveUsername: '已有帳號',
    save: '儲存',
    settlement: '結算',
    ProductSelection: '產品選擇',
    SalesChannel: '銷售渠道Sales',
    editLogPwd: '修改登錄密碼',
    editPayPwd: '修改提現密碼'
  },
  goodsCat: {
    beauty: '美妝',
    food: '食品',
    necessary: '日用品',
    ClothesShoes: '衣鞋',
    Infants: '嬰幼',
    Electrical: '電器3C',
    SkinCare: '保養品',
    SmallThings: '創意小物',
    other: '其他',
    FB: '社群FB',
    IG: 'IG',
    GOOGLE: 'GOOGLE',
    YOUTUBE: 'YOUTUBE',
    LIVE: '帶貨直播',
    TIKTOk: '抖音',
    OEM1: '充電綫包裝',
    OEM2: '色鉛筆包裝',
    OEM3: '吊飾加工',
    OEM4: '數字包裝',
    OEM5: '修眉刀包裝',
    OEM6: '襪子代工',
    OEM7: '粉撲包裝',
    OEM8: '紙盒代工',
    OEM9: '串珠代工',
    OEM10: '吊牌代工',
    OEM11: '紐扣包裝',
    OEM12: '口罩代工',
    OEM13: '髮圈包裝',
    OEM14: '髮圈代工',
    OEM15: '髮夾包裝',
    buyPop: '請先升級黃金會員!'
  },
  index: {
    bannerTip: '提供專業有效率且嚴格的電商銷售環境',
    bannerTitle: '銷售 通路 利潤',
    block2Title: '簡介',
    block2Tip1: '全新的快電商媒介，創始成員來自廣告業界專家，團隊每日銜接最優質之產品及通路。',
    block2Tip2: '透過創新橋梁創建全新流通獲益平台，以結合為重，創造公司金流市值，是對於未來快電商發展最有力的願景，營運方式即是以開放快電商平台為架構，符合創新及市場通路多元化服飾需求，將快電商所需一切之條件：產品、通路、客戶、金流、廣告媒介、銷售處理人員集合承接，結合智能數位服務與大數據行銷，使業務下單更加融入生活方式，符合未來最具影響力的快電商經營方式。',
    block3Title: '強大優勢',
    block3Tip: '開創新時代，助會員創造財富，助客戶獲得最佳產品',
    block3ItemTitle1: '移動應用',
    block3ItemTip1: '我們的介面可完美的適用於任何裝置，您可以輕鬆地瀏覽',
    block3ItemTitle2: '產品檢驗',
    block3ItemTip2: '我們的介面可完美的適用於任何裝置，您可以輕鬆地瀏覽',
    block3ItemTitle3: '業務極速銷貨',
    block3ItemTip3: '業務將選擇之商品利用廣告通路用極快速度進行完售，效率為主要核心',
    block3ItemTitle4: '通路國際化',
    block3ItemTip4: '通路為市面上最有效率之國際化工具，深入客戶及業務最深層',
    block4Title: '領先各大電商',
    block4Tip: '使用快電商產品與通路特性，把關產品及服務，使得業務優先選取，並使用大數據及企業管理平台保障各方受益',
    OverviewTitle: '了解世界市面快電商的產品',
    block5Title: '贊助及監管',
    block5Tip: '開創全新時代，助您創造及保管財富',
    block5Item1: '中華民國消費者文教基金會',
    block5Item2: '美國消費品安全委員會',
    block5Item3: '日本消費者廳',
    companyInfo: '本機構提供之電商交易為保護業務使用者及客戶之用途，使用上之風險由本公司承擔，若非本公司授權之用途本公司一概無權管理，您必須詳細了解業務原則及客戶協議。'
  },
  logRes: {
    inUsername: '輸入帳號',
    inPwd: '輸入密碼',
    realName: '真實姓名',
    inRealName: '輸入真實姓名',
    phoneNum: '手機號碼',
    inPhoneNum: 'ex:0987654321',
    phoneNumTip: '為了維護您的權利，註冊姓名/身分證/帳戶 須為同一人。請使用本人手機號碼且可接收簡訊。禁止利用多重身分申請大量帳號，造成資料重疊或點數遺失，後果自負。',
    username: '帳號名稱',
    inUser: '帳號需為3~20英數組合',
    reInpwd: '再次輸入密碼',
    softWare: '通訊軟體',
    inLine: '輸入LINE ID',
    inChat: '輸入WECHAT ID',
    InCode: '輸入驗證碼',
    checkTips: '確認本人已滿18歲且在此網站的所有活動，並沒有抵觸本人所身在的國家所管轄的法律。本人也接受在此項申請下有關的所有',
    isCheck: '請確認是否已滿18嵗',
    inputRealName: '請輸入真實姓名',
    inputPhone: '請輸入手機號碼',
    inputPwd: '請輸入密碼',
    inputRePwd: '請確認密碼',
    inputAccount: '請輸入賬號名稱',
    inputLinkId: '請輸入Line Id',
    inputWechat: '請輸入Wechat Id',
    difPwd: '兩次密碼不一致，請重新輸入',
    accountExist: '賬號已存在！',
    success: '成功！'
  },
  edit: {
    title: '修改資料',
    logUsername: '登入賬號',
    name: '姓名',
    editPwd: '修改密碼',
    inOldEditPwd: '輸入舊密碼',
    inEditPwd: '輸入新密碼',
    rePwd: '確認密碼',
    inRePwd: '再次輸入新密碼',
    tipTitle: '注意事項:',
    tipTips: '如遇不可抗拒因素，需要變更資料，請洽詢客服人員！',
    PwdNoEmpty: '新密碼不能爲空',
    rePwdNoEmpty: '確認密碼不能爲空',
    OldPwdNoEmpty: '舊密碼不能爲空',
    editPayPwd: ''
  },
  member: {
    salesSurplus: '銷售盈餘',
    TodayCustomers: '今日成交客戶',
    growthRate: '客戶成長率',
    salesGrowthRate: '營業額成長率',
    newsTitle: '最新消息',
    cateTitle: '銷貨中心、通路、贊助商',
    cateItem1: '產品選擇及國內外通路',
    cateItem2: '廠商加駐派遣',
    proListTitle: '產品選擇及通路',
    proListCate1: '產品類型',
    proListCate2: '國内外通路',
    proOEMTitle: '家庭代工'
  },
  record: {
    closeTitle: '結算明細',
    tab1: '購買記錄',
    tab2: '提現記錄',
    orderTime: '訂單日期',
    detail: '明細',
    mount: '金額',
    project: '項目',
    status: '狀態',
    Pending: '待處理',
    reject: '駁回',
    Processed: '已處理',
    ratio: '手续费'
  },
  buy: {
    RechargeTarget: '儲值目標',
    moneyTitle: '輸入金額',
    inMoney: '請輸入金額',
    tipTitle: '注意事項',
    tipTip1: '同一帳戶/家庭/戶籍地址/電話/IP地址/共享電腦/網路環境，視為相同，若查詢到多個帳號、同一IP，且交代不清者，一律視為詐騙帳號停權處分。',
    tipTip2: '申請點數需１０００點以上，請務必確認填寫之帳號，若提供的帳號錯誤，恕本公司無法負責。',
    tipTip3: '首次填寫帳號後，即永久綁定，恕不任意變更。',
    tipTip4: '如利用本平臺進行任何洗錢詐騙行為，本公司有權利審核帳戶或永久終止服務，不另行通知。'
  },
  withdraw: {
    title: '綫上提款',
    accountCount: '賬號餘額',
    withdrawMount: '提款金額',
    withdrawPwd: '提款密碼',
    tipTip1: '同一帳戶/家庭/戶籍地址/電話/IP地址/共享電腦/網路環境，視為相同，若查詢到多個帳號、同一IP，且交代不清者，一律視為詐騙帳號停權處分。',
    tipTip2: '請務必確認填寫之帳號，若提供的帳號錯誤，恕本公司無法負責。',
    tipTip3: '首次填寫帳號後，即永久綁定，恕不任意變更。',
    tipTip4: '如利用本平臺進行任何洗錢詐騙行為，本公司有權利審核帳戶或永久終止服務，不另行通知。'
  },
  bank: {
    title: '金融卡資料',
    bankName: '銀行名稱',
    inBankName: '輸入銀行名稱',
    bankAddress: '分行名稱',
    inBankAddress: '輸入分行名稱',
    bankAccount: '銀行賬號',
    inBankAccount: '輸入銀行賬號',
    bankPassword: '交易密碼',
    inBankPassword: '輸入交易密碼'
  },
  product: {
    productList: '產品列表',
    sold: '已售出',
    originalPrice: '原價',
    discount: '折扣',
    nowPrice: '最低價',
    detailed: '詳細介紹',
    productDetails: '產品詳情',
    buyNow: '立即購買'
  }
}
